import { Component } from "react";
import PropTypes from "prop-types";
import ReactDOM from "react-dom";

interface PortalState {
    mounted: boolean;
}

interface PortalProps {
    onUnmounted?: () => void;
    onMounted?: () => void;
    element: React.ReactNode | null;
    appendTo: HTMLElement;
    visible: boolean;
}

export class Portal extends Component<PortalProps, PortalState> {
    static defaultProps = {
        visible: false,
    };

    static propTypes = {
        element: PropTypes.any,
        appendTo: PropTypes.any,
        visible: PropTypes.bool,
        onMounted: PropTypes.func,
        onUnmounted: PropTypes.func,
    };

    constructor(props: PortalProps | Readonly<PortalProps>) {
        super(props);

        const hasDOM = typeof window !== "undefined" && typeof document !== "undefined";
        const mounted = props.visible && hasDOM;

        this.state = {
            mounted,
        };
    }

    componentDidMount() {
        const hasDOM = typeof window !== "undefined" && typeof document !== "undefined";
        if (hasDOM && !this.state.mounted) {
            this.setState({ mounted: true }, this.props.onMounted);
        }
    }

    componentWillUnmount() {
        this.props.onUnmounted && this.props.onUnmounted();
    }

    render() {
        const element = this.props.element || (this.props as any).children;
        if (element && this.state.mounted) {
            return ReactDOM.createPortal(element, this.props.appendTo);
        }

        return null;
    }
}
